<template>
<div class="content-body tenant-settings">
    <div class="">
        <!-- 技术通知类型 不同类型的模板 需要提供：QA -->
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
          <el-form-item label="子公司" label-width="100px">
            <el-select  v-model="dataForm.subcompanyId" @change="getSupCompanyList" style="width: 100%">
              <el-option
                  v-for="item in supCompanyList"
                  :key="item.id"
                  :label="item.orgName"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目选择:" label-width="100px">
            <el-input size="small" v-model="dataForm.projectCode" placeholder="项目选择" clearable @blur="getDataList" >
              <i slot="suffix" class="el-input__icon el-icon-search" @click="openProjectSearch" style="cursor:pointer"></i>
            </el-input>
          </el-form-item>
            <el-form-item label="项目名称:" label-width="100px">
                <el-input size="small" v-model="dataForm.projectName" placeholder="项目名称" clearable @blur="getDataList"></el-input>
            </el-form-item>
          <el-form-item label="项目车型:" label-width="112px">
            <el-input size="small" v-model="dataForm.carType" placeholder="项目车型" clearable @blur="getDataList" >
              <i slot="suffix" class="el-input__icon el-icon-search" @click="openCarTypeSearch" style="cursor:pointer"></i>
            </el-input>
          </el-form-item>
            <el-form-item label="申请状态:" >
                <el-select size="small" v-model="dataForm.technicalStatus" placeholder="请选择状态" clearable @change="getDataList">
                    <el-option v-for="item in PLM_TECHNICAL_INFO_STATUS" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <!--<el-cascader v-model="technicalStatuses" :options="PLM_TECHNICAL_INFO_STATUS" :props="{ multiple: false, checkStrictly: true }" collapse-tags clearable></el-cascader>-->
            </el-form-item><br>

            <el-form-item label="定点申请编码:">
                <el-input size="small" v-model="dataForm.technicalCode" placeholder="定点申请编码" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="定点申请主题:">
                <el-input size="small" v-model="dataForm.technicalName" placeholder="定点申请主题" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="采购项目工程师:">
                <el-input size="small" v-model="dataForm.projectManagerName" placeholder="采购项目工程师" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="接收状态:" >
               <!--<el-select size="small" v-model="dataForm.recieveStatus"  multiple placeholder="请选择状态" clearable @change="getDataList">
                    <el-option v-for="item in PLM_RECEIVE_STATUS" :key="item.value" :label="item.label" :value="item.value"></el-option>
               </el-select>-->
               <el-cascader v-model="receiveStatuses" :options="PLM_RECEIVE_STATUS" :props="{ multiple: true, checkStrictly: true }" collapse-tags clearable></el-cascader>
            </el-form-item>

            <el-form-item class="fr">
                <el-button size="small" @click="getDataList()" icon="el-icon-search" style="margin-left:10px">
                    查询
                </el-button>
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="id" size="mini" bProject style="width: 100%" :default-expand-all="false" border :header-cell-style="{ background: '#f5f5f5' }" :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="technicalCode" header-align="center" align="left" label="定点申请编码" width="160">
                </el-table-column>
                <el-table-column prop="technicalName" header-align="center" align="left" label="定点申请主题" width="160">
                </el-table-column>
                <el-table-column prop="werk" header-align="center" align="left" label="工厂" width="100">
                </el-table-column>
                <el-table-column prop="projectCode" header-align="center" align="left" label="项目选择" width="120">
                </el-table-column>
                <el-table-column prop="projectName" header-align="center" align="left" label="项目名称" width="140">
                </el-table-column>
                <el-table-column prop="carType" header-align="center" align="left" label="车型" width="100">
                </el-table-column>
                <el-table-column prop="projectManagerName" header-align="center" align="left" label="项目工程师" width="90">
                </el-table-column>
                <el-table-column prop="technicalType" header-align="center" align="center" label="申请类型" width="90">
                   <template slot-scope="scope">
                       <span>
                           {{ typeFormat(scope.row.technicalType) }}
                       </span>
                   </template>
                </el-table-column>
                <el-table-column prop="sourceType" header-align="center" align="center" label="招标类型" width="90">
                   <template slot-scope="scope">
                       <span v-if="scope.row.sourceType=='1'" >议标</span>
                       <span v-if="scope.row.sourceType=='0'" >招标</span>
                   </template>
                </el-table-column>
                <el-table-column prop="technicalStatus" class="status" header-align="center" align="center" label="申请状态" width="80">
                    <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.technicalStatus)">{{statusFormat(scope.row.technicalStatus)}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" header-align="center" align="right" label="创建时间" :formatter="dateFormat" width="140">
                </el-table-column>
                <el-table-column prop="receiveStatus" class="status" header-align="center" align="center" label="接收状态" width="80">
                    <template slot-scope="scope">
                        <span>{{ receiveStatusFormat(scope.row.receiveStatus) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="receiveUserName" header-align="center" align="left" label="接收/反馈人" width="90">
                </el-table-column>
                <el-table-column prop="updateTime" header-align="center" align="right" label="接收/反馈时间" :formatter="dateFormat" width="140">
                </el-table-column>
                <el-table-column header-align="center" align="left" min-width="130" label="操作" width="185">
                    <template slot-scope="scope">
                        <el-button :disabled="scope.row.projectManagerName == null" type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button :disabled="scope.row.projectManagerName == null || scope.row.receiveStatus != 0 || (scope.row.projectManagerName != null && userRealName != scope.row.projectManagerName) " type="text" size="small" @click="receiveHandle(scope.row)"  icon="el-icon-circle-check">
                            接收
                        </el-button>
                        <el-button :disabled="scope.row.projectManagerName == null || scope.row.receiveStatus != 0 || (scope.row.projectManagerName != null && userRealName != scope.row.projectManagerName)" type="text" size="small" @click="feedbackHandle(scope.row)"  icon="el-icon-circle-close">
                            反馈
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        <el-dialog :title="'提示'" width="30%" :close-on-click-modal="false" :visible.sync="feedbackReasonFlag">
            <el-form label-width="0px" :rules="dataRule" :model="dataForm2" ref="dataForm2">
                <el-form-item prop="feedbackReason">
                    <el-input type="textarea" :rows="2" placeholder="请输入反馈原因" v-model="dataForm2.feedbackReason">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="feedbackReasonFlag = false">取 消</el-button>
                <el-button type="primary" @click="UpdateByFeedback()">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog
              title="提示"
              :close-on-click-modal="false"
              :visible.sync="dialogVisible"
              width="30%">
              <span>{{content}}</span>
              <span slot="footer" class="dialog-footer">
                <el-button @click="cancelAction">取 消</el-button>
                <el-button :loading="isLoading" type="primary" @click="confirmAction">确 定</el-button>
              </span>
        </el-dialog>
      <el-dialog title="项目选择" :visible.sync="projectSearchVisible" width="60%" :close-on-click-modal="false">
        <el-form :inline="true" :model="projectSearchForm" size="small">
          <el-form-item label="项目编码:">
            <el-input v-model="projectSearchForm.projectCode" placeholder="项目编码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchProjects">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="projectSearchList" border height="300" @row-dblclick="selectProject" ref="projectSearchTable" @current-change="handleProjectSelectChange" highlight-current-row>
          <el-table-column prop="projectCode" label="项目编码" width="150"></el-table-column>
          <el-table-column prop="projectName" label="项目名称" width="200"></el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="projectSearchVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmSelectProject">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 车型搜索帮助 -->
      <el-dialog title="项目车型选择" :visible.sync="carTypeSearchVisible" width="50%" :close-on-click-modal="false">
        <el-form :inline="true" :model="carTypeSearchForm" size="small">
          <el-form-item label="车型:">
            <el-input v-model="carTypeSearchForm.carType" placeholder="车型"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchCarTypes">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="carTypeSearchList" border height="300" @row-dblclick="selectCarType" ref="carTypeSearchTable" @current-change="handleCarTypeSelectChange" highlight-current-row>
          <el-table-column prop="carType" label="项目车型"></el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="carTypeSearchVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmSelectCarType">确 定</el-button>
        </div>
      </el-dialog>
    </div>
</div>
</template>

<script>
import {
    getLabelByValue,
    PLM_TECHNICAL_TYPE,
    PLM_RECEIVE_STATUS,
    PLM_TECHNICAL_INFO_STATUS,
} from "@/utils/const";
import AddOrUpdate from "./tech-add-or-update";
import moment from "moment";
import {getUserInfoByToken} from '@/controller/sys'
import {
    fetchTechList,
    receiveOrFeedBackTech,
    getNoExistPartsByTechIdAndFactory,
    projectCodeSelect,
    CarTypeSelect
} from "@/controller/plmTech";

import {
    getTechnicalByTechCode
} from "@/controller/tech";
import {supCompanyList} from "../../../../controller/sys";
// require('@/mock/mockTech');
export default {
    data() {
        return {
            documentClientHeight: document.documentElement["clientHeight"] - 250,
            PLM_TECHNICAL_TYPE: PLM_TECHNICAL_TYPE,
            PLM_TECHNICAL_INFO_STATUS: PLM_TECHNICAL_INFO_STATUS,
            PLM_RECEIVE_STATUS: PLM_RECEIVE_STATUS,
            dataForm: {
                projectCode: "",
                projectName: "",
                technicalCode: "",
                technicalName: "",
                carType: "",
                technicalStatus: "",
                technicalType: "",
                partCount: "",
                issueTime: "",
                createTime: "",
                receiveStatuses: [],
                technicalStatuses: [],
                projectManagerName: "",
            },
            technicalStatuses: [

            ],
            receiveStatuses: [
                [0]
            ],
            getLabelByValue: getLabelByValue,
            dataList: [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false,
            dataForm2: {
                feedbackReason: '',
                id : '',
                uid : '',
                technicalCode : '',
                version : '',
                receiveStatus : '',
            },
            feedbackReasonFlag: false,
            userRealName: '',
            receiveButtonFlag: false,
            dialogVisible: false,
            content:'',
            isLoading: false,
            rowData:{},
            supCompanyList: [],
            projectSearchVisible: false,
            carTypeSearchVisible: false,
            projectSearchList: [],
            carTypeSearchList: [],
            projectSearchForm: {
              projectCode: '',
              projectName: ''
            },
            carTypeSearchForm: {
              carType: ''
            },
          selectedProjectRow: null,  // 添加选中的项目行
          selectedCarTypeRow: null   // 添加选中的车型行
        };
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 270;
            },
        },
    },
    components: {
        AddOrUpdate,
    },
    activated() {

    },
    mounted() {
        // this.dataForm="";
        this.getUserInfo();
    },
    methods: {
        //打开项目搜索帮助
        openProjectSearch() {
          this.projectSearchForm = {
            projectCode: ''
          };
          this.selectedProjectRow = null;
          this.searchProjects();
          this.projectSearchVisible = true;
        },
      //处理项目选择变化
      handleProjectSelectChange(currentRow) {
        this.selectedProjectRow = currentRow;
      },

        //搜索项目
        searchProjects() {
          projectCodeSelect({projectCode: this.projectSearchForm.projectCode})
              .then((data) => {
                if (data && data.code === "00") {
                  this.projectSearchList = data.body;
                } else {
                  this.projectSearchList = [];
                }
              });
        },

        //选择项目
        selectProject(row) {
          this.dataForm.projectCode = row.projectCode;
          this.projectSearchVisible = false;
          this.getDataList();
        },

      //确认选择项目
      confirmSelectProject() {
        if(this.selectedProjectRow) {
          this.dataForm.projectCode = this.selectedProjectRow.projectCode;
          this.projectSearchVisible = false;
          this.getDataList();
        } else {
          this.$message.warning("请先选择一条记录");
        }
      },

        //打开车型搜索帮助
        openCarTypeSearch() {
          this.carTypeSearchForm = {
            carType: ''
          };
          this.selectedCarTypeRow = null;
          this.searchCarTypes();
          this.carTypeSearchVisible = true;
        },
      //处理车型选择变化
      handleCarTypeSelectChange(currentRow) {
        this.selectedCarTypeRow = currentRow;
      },
        //搜索车型
        searchCarTypes() {
          CarTypeSelect({carType: this.carTypeSearchForm.carType})
              .then((data) => {
                if (data && data.code === "00") {
                  this.carTypeSearchList = data.body;
                } else {
                  this.carTypeSearchList = [];
                }
              });
        },

        //选择车型
        selectCarType(row) {
          this.dataForm.carType = row.carType;
          this.carTypeSearchVisible = false;
          this.getDataList();
        },

      //确认选择车型
      confirmSelectCarType() {
        if(this.selectedCarTypeRow) {
          this.dataForm.carType = this.selectedCarTypeRow.carType;
          this.carTypeSearchVisible = false;
          this.getDataList();
        } else {
          this.$message.warning("请先选择一条记录");
        }
      },
        //判断技术通知管理状态
        judgeTechnicalStatus(val) {
            if (val === '0' || val === '5') {
                this.isActive = true
                return false
            } else {
                this.isActive = false
                return true
            }
        },
        dateFormat: function (row, column) {
            var date = row[column.property];
            if (date == undefined) {
                return "";
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss");
        },
        statusFormat: function (value) {
            if (!value) {
                return "";
            }
            return getLabelByValue(PLM_TECHNICAL_INFO_STATUS, value);
        },
        typeFormat: function (value) {
            // debugger;
            if (!value) {
                return "";
            }
            return getLabelByValue(PLM_TECHNICAL_TYPE, value);
        },
        receiveStatusFormat: function (value) {
            if (!value) {
                return "";
            }
            return getLabelByValue(PLM_RECEIVE_STATUS, value);
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true;
            this.dataForm.technicalStatuses = []
            this.technicalStatuses.forEach(status => {
                this.dataForm.technicalStatuses.push(status[0])
            })
            this.dataForm.receiveStatuses = []
            this.receiveStatuses.forEach(status => {
                this.dataForm.receiveStatuses.push(status[0])
            })
            fetchTechList({
                    pageNo: this.pageIndex,
                    pageSize: this.pageSize,
                    projectCode: this.dataForm.projectCode,
                    projectName: this.dataForm.projectName,
                    carType: this.dataForm.carType,
                    technicalCode: this.dataForm.technicalCode,
                    technicalName: this.dataForm.technicalName,
                    projectManagerName: this.dataForm.projectManagerName,
                    technicalStatus: this.dataForm.technicalStatus,
                    receiveStatuses: this.dataForm.receiveStatuses,
                    subcompanyId:this.dataForm.subcompanyId,
                })
                .then((data) => {
                    // console.log(data, 'data')
                    if (data && data.code === "00") {
                        this.dataList = data.body.records;
                        this.totalPage = data.body.total;
                    } else {
                        this.dataList = [];
                        this.totalPage = 0;
                    }
                })
                .catch((e) => {
                    console.log(e);
                })
                .finally(() => {
                    this.dataListLoading = false;
                });
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
        },
        // 查看
        viewHandle(row) {
            // console.log(row);
            this.addOrUpdateVisible = true;
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, "view");
            });
        },

        // 确认
        addOrUpdateHandleConfirm(row) {

            this.addOrUpdateVisible = true;
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, "view", "confirm");
            });
        },

        getStatusClass(status) {
            let className = "";
            switch (status) {
                case "0":
                    className = "text-primary";
                    break;
                case "5":
                    className = "text-danger";
                    break;
                default:
                    className = "text-success";
                    break;
            }
            return className;
        },
        // 获取当前登录人员信息
        getUserInfo() {
            getUserInfoByToken({}).then(data => {
                if (data && data.code === '00') {
                    this.dataForm.projectManagerName = data.body.user.realName
                    this.userRealName = data.body.user.realName
                    this.getSupCompanyList();
                    this.getDataList();
                }
            })
        },
        //获取子公司列表
        getSupCompanyList(){
          supCompanyList().then(res=>{
            if(res && res.code == '00'){
              this.supCompanyList = res.body;
            }
          })
        },
        // 接收
        receiveHandle(row) {
            this.isLoading = false;
            this.content = '确定执行接收操作吗？'
            this.rowData = row
            this.dialogVisible = true;
        },
        cancelAction() {
          this.isLoading = false;
          this.dialogVisible = false;
        },
        // 执行确认操作
        confirmAction() {
          let row = this.rowData
          // 如果申请单状态为发布
          if(row.technicalStatus == '1') {
              //开始接收
              this.isLoading = true;
              receiveOrFeedBackTech({
                  'id': row.id,
                  'uid': row.uid,
                  'technicalCode': row.technicalCode,
                  'version': row.version,
                  'receiveStatus': "1",
              }).then(data => {
                  if (data && data.code === '00') {
                  } else if (data && data.code === '01') {
                      this.$message({
                          message: data.msg,
                          type: 'warning'
                      })
                  }
              }).catch((e) => {
                  console.log(e)
              }).finally(() => {
                  this.getDataList()
                  this.isLoading = false;
                  this.dialogVisible = false;
              })
          } else if(row.technicalStatus == '2') {
              //如果plm定点申请状态为作废
              getTechnicalByTechCode({}, row.technicalCode).then((data) => {
                  if (data && data.code === "00") {
                      if(data.body == null) {
                           this.$message({
                              message: "没有找到对应的定点申请数据",
                              type: 'warning'
                           })
                      }
                      else if(data.body.technicalStatus == "1") {
                          //已发布，给提示，用户确定后再去修改plm定点申请状态
                          var msg = "定点申请"+row.technicalCode+"已经发布，确定要接收这一作废申请吗？"
                          this.$confirm(msg, '提示', {
                              confirmButtonText: '确定',
                              cancelButtonText: '取消',
                              type: 'warning'
                          }).then(() => {
                              this.dataListLoading = true
                              receiveOrFeedBackTech({
                                  'id': row.id,
                                  'uid': row.uid,
                                  'technicalCode': row.technicalCode,
                                  'version': row.version,
                                  'receiveStatus': "1",
                              }).then(data => {
                                  if (data && data.code === '00') {
                                      this.getDataList()
                                  } else if (data && data.code === '01') {
                                      this.$message({
                                          message: data.msg,
                                          type: 'warning'
                                      })
                                      this.getDataList()
                                  }
                              }).catch((e) => {
                                console.log(e)
                              }).finally(() => {
                                this.getDataList()
                                this.isLoading = false;
                                this.dialogVisible = false;
                              })
                          })
                      }
                      else if(data.body.technicalStatus === "0" || data.body.technicalStatus === "5"){
                          //如果“未发布“ 或“已退回”，请求服务
                          this.dataListLoading = true
                          receiveOrFeedBackTech({
                              'id': row.id,
                              'uid': row.uid,
                              'technicalCode': row.technicalCode,
                              'version': row.version,
                              'receiveStatus': "1",
                          }).then(data => {
                              if (data && data.code === '00') {
                                  this.getDataList()
                              } else if (data && data.code === '01') {
                                  this.$message({
                                      message: data.msg,
                                      type: 'warning'
                                  })
                                  this.getDataList()
                              }
                          }).catch((e) => {
                            console.log(e)
                          }).finally(() => {
                            this.getDataList()
                            this.isLoading = false;
                            this.dialogVisible = false;
                          })
                      }
                  }
              });
          }
          else if(row.technicalStatus == '3') {
            //如果plm定点申请状态为变更
            getTechnicalByTechCode({}, row.technicalCode).then((data) => {
              if (data && data.code === "00") {
                if(data.body == null) {
                  this.$message({
                    message: "没有找到对应的定点申请数据",
                    type: 'warning'
                  })
                }
                else if(data.body.technicalStatus == "1") {
                  //已发布，给提示，用户确定后再去修改plm定点申请状态
                  var msg = "定点申请"+row.technicalCode+"已经发布，确定要接收这一变更申请吗？"
                  this.$confirm(msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => {
                    this.dataListLoading = true
                    receiveOrFeedBackTech({
                      'id': row.id,
                      'uid': row.uid,
                      'technicalCode': row.technicalCode,
                      'version': row.version,
                      'receiveStatus': "1",
                    }).then(data => {
                      if (data && data.code === '00') {
                        this.getDataList()
                      } else if (data && data.code === '01') {
                        this.$message({
                          message: data.msg,
                          type: 'warning'
                        })
                        this.getDataList()
                      }
                    }).catch((e) => {
                      console.log(e)
                    }).finally(() => {
                      this.getDataList()
                      this.isLoading = false;
                      this.dialogVisible = false;
                    })
                  })
                }
                else if(data.body.technicalStatus === "0" || data.body.technicalStatus === "5"){
                  //如果“未发布“ 或“已退回”，请求服务
                  this.dataListLoading = true
                  receiveOrFeedBackTech({
                    'id': row.id,
                    'uid': row.uid,
                    'technicalCode': row.technicalCode,
                    'version': row.version,
                    'receiveStatus': "1",
                  }).then(data => {
                    if (data && data.code === '00') {
                      this.getDataList()
                    } else if (data && data.code === '01') {
                      this.$message({
                        message: data.msg,
                        type: 'warning'
                      })
                      this.getDataList()
                    }
                  }).catch((e) => {
                    console.log(e)
                  }).finally(() => {
                    this.getDataList()
                    this.isLoading = false;
                    this.dialogVisible = false;
                  })
                }
              }
            });
          }
        },

        // 反馈
        feedbackHandle(row) {
            this.dataForm2.id = row.id
            this.dataForm2.uid = row.uid
            this.dataForm2.technicalCode = row.technicalCode
            this.dataForm2.version = row.version
            this.dataForm2.receiveStatus = "2"
            this.dataForm2.feedbackReason = ""
            this.feedbackReasonFlag = true;
        },
        // 反馈
        UpdateByFeedback(){
            let params = {
              'id': this.dataForm2.id,
              'uid': this.dataForm2.uid,
              'technicalCode': this.dataForm2.technicalCode,
              'version': this.dataForm2.version,
              'receiveStatus': "2",
              'rejectReason' : this.dataForm2.feedbackReason
            }
            console.log(params)
            receiveOrFeedBackTech(params).then(data => {
                if (data && data.code === '00') {
                    this.getDataList()
                this.$message({
                    message: '反馈成功',
                    type: 'success',
                    duration: 500,
                    onClose: () => {
                        this.visible = false
                        this.$emit('refreshDataList')
                        this.feedbackReasonFlag = false
                    }
                })
                } else {
                    this.$message.error(data.msg)
                }
            })



        },
    },
};
</script>

<style lang="scss" scoped>
.input-width {
    width: 155px;
}
</style>
